import { render, staticRenderFns } from "./robotCallRecord.vue?vue&type=template&id=4eea2a6e&scoped=true&"
import script from "./robotCallRecord.vue?vue&type=script&lang=ts&"
export * from "./robotCallRecord.vue?vue&type=script&lang=ts&"
import style0 from "./robotCallRecord.vue?vue&type=style&index=0&id=4eea2a6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eea2a6e",
  null
  
)

export default component.exports